import type { TFunction } from 'i18next';

/** `message` 429, gdy organizacja nie ma uruchomionej puli tokenów AI (np. okładki asystenta). */
export const AI_POOL_REQUIRED = 'ai_pool_required';

/**
 * Czy błąd z axios (lub z `fetch` przepakowany do `{ response: { status, data } }`) to 429 brak puli
 * AI. Globalny interceptor tego nie toastuje, więc komunikat pokazuje wywołujący.
 */
export const isAiPoolRequiredError = (e: unknown): boolean => {
  const res = (e as { response?: { status?: number; data?: { message?: unknown } | null } } | null)?.response;
  return res?.status === 429 && res.data?.message === AI_POOL_REQUIRED;
};

/** Błąd, który globalny interceptor zamienił po pokazaniu toastu „limit AI wyczerpany”. */
export const isAiLimitHandledError = (e: unknown): boolean => {
  const err = e as { message?: unknown } | null;
  return err?.message === 'AI_LIMIT_HANDLED';
};

/** Ten sam komunikat co przy okładkach i awatarze asystenta. */
export const aiPoolRequiredMessage = (t: TFunction): string => t(
  'aiChat.cover.poolRequired',
  'Pula tokenów AI nie jest uruchomiona. Zgłoś się do administratora, aby ją włączyć.',
);

/**
 * Czy 429 to wyczerpany limit tokenów AI, który obsługuje globalny toast. Brak puli
 * (`ai_pool_required`) to nie wyczerpany limit: błąd idzie do wywołującego z `message`,
 * który pokazuje własny komunikat.
 */
export const isAiLimitExceeded = (status: number | undefined, data: unknown): boolean => {
  const d = (data ?? {}) as { error?: unknown; message?: unknown };
  return status === 429 && d.error === 'AI token limit exceeded' && d.message !== AI_POOL_REQUIRED;
};

declare module 'axios' {
  interface AxiosRequestConfig {
    /**
     * Wywołanie samo obsługuje brak tokenów AI (np. hero agenta w tle): interceptor nie pokazuje
     * globalnego toastu „limit wyczerpany” i oddaje oryginalny błąd 429.
     */
    skipAiLimitToast?: boolean;
  }
}

/** Czy interceptor ma pokazać globalny toast limitu AI dla tej odpowiedzi. */
export const shouldShowAiLimitToast = (
  status: number | undefined,
  data: unknown,
  config?: { skipAiLimitToast?: boolean },
): boolean => !config?.skipAiLimitToast && isAiLimitExceeded(status, data);
